var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBox = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 0.333496L25.6668 7.66683V22.3335L13.0002 29.6668L0.333496 22.3335V7.66683L13.0002 0.333496ZM4.32534 8.4371L13.0003 13.4594L21.6751 8.43715L13.0002 3.41483L4.32534 8.4371ZM3.00016 10.7512V20.796L11.667 25.8136V15.7688L3.00016 10.7512ZM14.3336 25.8135L23.0002 20.796V10.7513L14.3336 15.7688V25.8135Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Box.9042034c.svg";
export { ForwardRef as ReactComponent };